import { sortBy } from "lodash";
import CONSTANTS from "../helpers/Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  login: {
    url: "/app/adminLogin",

    method: "POST",
    data: {
      email: "",
      password: "",
      deviceId: "",
      signinType: "",
      socialId: "",
      platformType: "web",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },

  adminFeeds: {
    url: "/ui/feed/postListByAdmin?userId=:userId&skip=:skip",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  adminCreateFeed: {
    url: "/ui/feed",
    method: "POST",
    data: {
      post: {
        text: "",
        images: [],
        media: "",
      },
      postedBy: "",
      dateTime: "",
      status: "",
      visibility: "",
      scope: [],
      interest: [],
      isActive: "",
      tags: [],
      groupId: "",
      lastActivityTime: "",
      lastActivityType: "",
      //metaTags: {}
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getMetatag: {
    url: "http://api.linkpreview.net/?key=5dbfe295e9fe08d015dd00e22eb3807e03c786d28f0b7&q=:q",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getUrlMetaData: {
    url: "ui/feed/urlMetaData",
    method: "PUT",
    data: {
      url: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  signupStudent: {
    url: "/app/signup",
    method: "POST",
    data: {
      firstName: "",
      lastName: "",
      email: "",
      parentEmail: "",
      parentFirstName: "",
      parentLastName: "",
      roleId: "",
      dob: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  signupParent: {
    url: "/app/signup",
    method: "POST",
    data: {
      firstName: "",
      lastName: "",
      email: "",
      roleId: "",
      students: [],
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  roleType: {
    url: "/app/roleType",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  forgotPassword: {
    url: "/app/reset/password?email=:email",
    method: "POST",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  resetPassword: {
    url: "/app/signup",
    method: "POST",
    data: {
      firstName: "",
      lastName: "",
      email: "",
      parentEmail: "",
      roleId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  logout: {
    url: "/ui/logout",
    method: "post",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  changePassword: {
    url: "/ui/update/password",
    method: "POST",
    data: {
      oldPassword: "",
      newPassword: "",
      isAcceptedTermCon: "",
      requestType: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getStudentPersonalInfo: {
    url: "/ui/personalInfo/:userId/false",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateStudentPersonalInfo: {
    url: "/ui/personalInfo",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      firstName: "",
      lastName: "",
      gender: "",
      genderAtBirth: "",
      dob: "",
      usCitizenOrPR: "",
      parents: [],
      address: {
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
      requireParentApproval: "",
      ccToParents: "",
      summary: "",
      tagline: "",
      mobileNo: "",
      title: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  addEducation: {
    url: "/ui/education",
    method: "POST",
    data: {
      userId: "",
      organizationId: "",
      logo: "",
      institute: "",
      city: "",
      fromYear: "",
      toYear: "",
      fromGrade: "",
      toGrade: "",
      //fieldOfStudy: '',
      //grade: '',
      //fromDate: '',
      //toDate: '',
      description: "",
      isActive: "",
      type: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  editEducation: {
    url: "/ui/education",
    method: "PUT",
    data: {
      educationId: "",
      userId: "",
      logo: "",
      organizationId: "",
      institute: "",
      city: "",
      fromYear: "",
      toYear: "",
      fromGrade: "",
      toGrade: "",
      //fieldOfStudy: '',
      //grade: '',
      //fromDate: '',
      //toDate: '',
      description: "",
      isActive: "",
      type: "School",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getEducation: {
    url: "/ui/education?educationId=:educationId",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  deleteEducation: {
    url: "/ui/education",
    method: "DELETE",
    data: {
      educationId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  ListOragnization: {
    url: "/ui/organization",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  getAllEducation: {
    url: "/ui/education?userId=:userId",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  // updateProfileImage: {
  //   url: "/ui/user",
  //   method: "PUT",
  //   data: {
  //     profilePicture: "",
  //     userId: "",
  //   },
  //   showResultMessage: false,
  //   showErrorMessage: false,
  // },

  updateUserSummary: {
    url: "/ui/user",
    method: "PUT",
    data: {
      summary: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateCoverImage: {
    url: "/ui/user",
    method: "PUT",
    data: {
      coverImage: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateUserTagline: {
    url: "/ui/user",
    method: "PUT",
    data: {
      tagline: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateName: {
    url: "/ui/user",
    method: "PUT",
    data: {
      firstName: "",
      lastName: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  getSASToken: {
    url: "ui/azure/sas",
    method: "POST",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getAllCompetency: {
    url: "ui/competencyAllLevel",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getCompetencyById: {
    url: "/ui/competencyType?competencyTypeId=:competencyTypeId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getSkills: {
    url: "ui/skills",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getImportance: {
    url: "ui/importance",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  addAchievement: {
    url: "/ui/achievement",
    method: "POST",
    data: {
      achievementId: "",
      competencyTypeId: "",
      level2Competency: "",
      level3Competency: "",
      userId: "",
      badge: [],
      certificate: [],
      asset: [],
      skills: [],
      title: "",
      description: "",
      fromDate: "",
      toDate: "",
      importance: "",
      guide: [],
      stories: "",
      isActive: "true",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  editAchievement: {
    url: "/ui/achievement",
    method: "PUT",
    data: {
      achievementId: "",
      competencyTypeId: "",
      level2Competency: "",
      level3Competency: "",
      userId: "",
      badge: [],
      certificate: [],
      asset: [],
      skills: [],
      title: "",
      description: "",
      fromDate: "",
      toDate: "",
      importance: "",
      guide: [],
      stories: "",
      isActive: "true",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  listAchievementByUser1: {
    url: "/ui/achievementByLevel2/:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  listAchievementByUser: {
    url: "/ui/narratives/:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getAchievementById: {
    url: "/ui/achievement?achievementId=:achievementId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  deleteAchievement: {
    url: "/ui/achievement",
    method: "DELETE",
    data: {
      achievementId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  spiderGraph: {
    url: "/ui/spider/chart/:userId/:sharedId",
    method: "GET",
    data: {},
    showErrorMessage: false,
    showResultMessage: false,
  },

  getStudentsByParentProfile: {
    url: "/ui/user/studentsbyparent/:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateUserProfile: {
    url: "/ui/personalInfo",
    method: "PUT",
    data: {
      userId: "",
      firstName: "",
      lastName: "",
      students: [],
      roleId: "",
      isActive: "",
      address: {
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  listRecommendationByUser: {
    url: "/ui/user/recommendations?userId=:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateRecommendation: {
    url: "/ui/recommendation",
    method: "PUT",
    data: {
      recommendationId: "",
      recommendation: "",
      competencyTypeId: "",
      level3Competency: "",
      title: "",
      skills: [],
      stage: "",
      badge: [],
      certificate: [],
      asset: [],
      recommenderId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  getRecommendationById: {
    url: "/ui/recommendation?recommendationId=:recommendationId",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  addRecommendation: {
    url: "/ui/recommendation",
    method: "POST",
    data: {
      userId: "",
      competencyTypeId: "",
      level2Competency: "",
      level3Competency: "",
      badge: [],
      certificate: [],
      asset: [],
      skills: [],
      title: "",
      request: "",
      interactionStartDate: "",
      interactionEndDate: "",
      firstName: "",
      lastName: "",
      email: "",
      recommendation: "",
      recommenderId: "",
      stage: "",
      name: "",
      profileImage: "",
      requesterEmail: "",
      recommenderTitle: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  deleteRecommendation: {
    url: "/ui/recommendation",
    method: "DELETE",
    data: {
      recommendationId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  searchProfile: {
    url: "ui/search?name=:name&like=true",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  addConnection: {
    url: "ui/connect",
    method: "POST",
    data: {
      userId: "",
      partnerId: "",
      dateTime: "",
      status: "",
      isActive: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  updateConnection: {
    url: "ui/connect",
    method: "PUT",
    data: {
      connectId: "",
      // userId: '',
      //partnerId: '',
      dateTime: "",
      status: "",
      isActive: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  deleteConnection: {
    url: "ui/connect",
    method: "DELETE",
    data: {
      connectId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getCount: {
    url: "ui/counts/:userId/:sharedId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  addToProfileRecommendation: {
    url: "ui/recommendation ",
    method: "PUT",
    data: {
      recommendationId: "",
      stage: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getConnectionStatus: {
    url: "ui/connect/status?userId=:userId&partnerId=:partnerId ",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  connectionList: {
    url: "ui/connect/list?userId=:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getChatConnections: {
    url: "ui/connect/chatList?userId=:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getChatFriendList: {
    url: "ui/message/friendList/info?userId=:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getChatMessage: {
    url: "ui/message?connectorId=:connectorId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  sendMessage: {
    url: "/ui/message",
    method: "POST",
    data: {
      connectorId: "",
      sender: "",
      receiver: "",
      time: "",
      text: "",
      type: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  subscribeRequest: {
    url: "ui/subscription",
    method: "POST",
    data: {
      userId: "",
      followerId: "",
      followerName: "",
      dateTime: "",
      isActive: "",
      status: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  unsubscribeRequest: {
    url: "ui/subscription",
    method: "PUT",
    data: {
      subscribeId: "",
      userId: "",
      followerId: "",
      followerName: "",
      dateTime: "",
      isActive: "",
      status: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getSubscriptionStatus: {
    url: "ui/subscription?userId=:userId&followerId=:followerId ",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  getSubscribersCount: {
    url: "ui/subscription?followerId=:userId",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  updateUserStatus: {
    url: "/ui/user/updateUserStatus",
    method: "PUT",
    data: {
      userId: "",
      isActive: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  createFeed: {
    url: "/ui/feed",
    method: "POST",
    data: {
      post: {
        text: "",
        images: [],
        media: "",
      },
      postedBy: "",
      dateTime: "",
      status: "",
      visibility: "",
      scope: [],
      isActive: "",
      tags: [],
      groupId: "",
      lastActivityTime: "",
      lastActivityType: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  updateFeed: {
    url: "/ui/feed/update",
    method: "PUT",
    data: {
      feedId: "",
      visibility: "",
      scope: [],
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  updateLastActivityTime: {
    url: "/ui/feed/update",
    method: "PUT",
    data: {
      feedId: "",
      lastActivityTime: "",
      lastActivityType: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  listFeed: {
    url: "/ui/feed/postList?userId=:userId&skip=:skip",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  // addFeedComment: {
  //   url: "ui/feed/addComment",
  //   method: "PUT",
  //   data: {
  //     feedId: "",
  //     userId: "",
  //     comment: "",
  //     dateTime: "",
  //     name: "",
  //     title: "",
  //     profilePicture: "",
  //     lastActivityTime: "",
  //     lastActivityType: "",
  //   },
  //   showResultMessage: false,
  //   showErrorMessage: false,
  // },

  deleteFeed: {
    url: "ui/feed",
    method: "DELETE",
    data: {
      feedId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  deleteComment: {
    url: "/ui/remove/comment",
    method: "POST",
    data: {
      feedId: "",
      commentId: "",
      dateTime: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  likeFeed: {
    url: "ui/feed/addLike",
    method: "PUT",
    data: {
      feedId: "",
      userId: "",
      isLike: "",
      lastActivityTime: "",
      lastActivityType: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  likeOnComment: {
    url: "ui/feed/addLike",
    method: "PUT",
    data: {
      feedId: "",
      userId: "",
      isLike: "",
      commentId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  shareFeed: {
    url: "/ui/share/feed",
    method: "POST",
    data: {
      feedId: "",
      postedBy: "",
      postOwner: "",
      visibility: "",
      scope: [],
      shareTime: "",
      shareText: "",
      isActive: "",
      lastActivityTime: "",
      lastActivityType: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  updateHeaderCount: {
    url: "/ui/header",
    method: "PUT",
    data: {
      userId: "",
      connectionCount: 0,
      messagingCount: 0,
      notificationCount: 0,
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  getHeaderCount: {
    url: "ui/header?userId=:userId",
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  createHeaderCount: {
    url: "/ui/header",
    method: "POST",
    data: {
      userId: "",
      connectionCount: 0,
      messagingCount: 0,
      notificationCount: 0,
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  mutualFriendList: {
    url: "/ui/mutual/friendlist?userId=:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  notificationList: {
    url: "/ui/notification?userId=:userId&skip=:skip",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  // postNotification: {
  //   url: "/ui/notification",
  //   method: "POST",
  //   data: {
  //     userId: "",
  //     actedBy: "",
  //     postId: "",
  //     profilePicture: "",
  //     text: "",
  //     dateTime: 0,
  //     isRead: false,
  //   },
  //   showResultMessage: false,
  //   showErrorMessage: false,
  // },

  deleteNotification: {
    url: "/ui/notification",
    method: "DELETE",
    data: {
      notificationId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  deleteAllNotification: {
    url: "/ui/notification",
    method: "DELETE",
    data: {
      userId: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  getSkillsCount: {
    url: "/ui/skills/counts/:userId/:sharedId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  shareStudentProfile: {
    url: "/ui/share/profile",
    method: "POST",
    data: {
      sharedType: "",
      profileOwner: "",
      firstName: "",
      lastName: "",
      email: "",
      shareTime: "",
      shareConfiguration: [],
      sharedView: "",
      isActive: "",
      theme: "",
      soundtrack: [],
    },
    showErrorMessage: false,
    showResultMessage: false,
  },

  updateShareMessageProfile: {
    url: "/ui/share/profile",
    method: "PUT",
    data: {
      sharedId: "",
      shareTo: "",
    },
    showErrorMessage: false,
    showResultMessage: false,
  },

  isShareProfileViewed: {
    url: "/ui/share/profile",
    method: "PUT",
    data: {
      sharedId: "",
      isViewed: "",
      lastViewedTime: "",
    },
    showErrorMessage: false,
    showResultMessage: false,
  },

  getSharedProfileConfiguration: {
    url: "/ui/share/profile?sharedId=:sharedId",
    method: "GET",
    data: {},
    showErrorMessage: false,
    showResultMessage: false,
  },

  addParentProfile: {
    url: "/ui/add/parent",
    method: "POST",
    data: {
      roleId: "",
      firstName: "",
      lastName: "",
      email: "",
      parentId: "",
      studentId: "",
      parentName: "",
    },
    showErrorMessage: false,
    showResultMessage: false,
  },

  removeStudentUser: {
    url: "/ui/user/detach",
    method: "PUT",
    data: {
      studentId: "",
      parentId: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  updateParentUserProfile: {
    url: "/ui/user",
    method: "PUT",
    data: {
      userId: "",
      firstName: "",
      lastName: "",
      roleId: "",
      isActive: "",
      address: {
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  getSharingProfileLog: {
    url: "/ui/share/profile/list?profileOwner=:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  revokeShareProfile: {
    url: "/ui/share/profile",
    method: "PUT",
    data: {
      sharedId: "",
      isActive: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  createGroups: {
    url: "/ui/group",
    method: "POST",
    data: {
      groupName: "",
      type: "",
      creationDate: "",
      createdBy: "",
      isActive: true,
      members: [],
      aboutGroup: "",
      otherInfo: "",
      groupImage: "",
    },
    showErrorMessage: true,
    showResultMessage: true,
  },

  getGroupListByUser: {
    url: "/ui/group/mygroups/:userId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getGroupMemberListByGroupId: {
    url: "/ui/group/members/:groupId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  deleteGroupByGroupId: {
    url: "/ui/group",
    method: "DELETE",
    data: {
      groupId: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  revokeGroupByGroupId: {
    url: "/ui/group/leave",
    method: "POST",
    data: {
      userId: "",
      groupId: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  listFeedByGroupId: {
    url: "/ui/feed/postListByGroupId?groupId=:groupId&skip=:skip",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  inviteGroupMember: {
    url: "/ui/group/inviteMembers",
    method: "POST",
    data: {
      members: [],
      groupId: "",
      firstName: "",
      lastName: "",
      email: "",
      invitedBy: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  updateMemberStatus: {
    url: "/ui/group/updateMemberStatus",
    method: "PUT",
    data: {
      groupId: "",
      userId: "",
      status: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getUserListByRole: {
    url: "ui/user?roleId=1&isActive=true",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateGroupInfo: {
    url: "/ui/group/updateGroupInfo",
    method: "PUT",
    data: {
      groupId: "",
      groupName: "",
      aboutGroup: "",
      otherInfo: "",
      type: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  updateGroupImage: {
    url: "/ui/group",
    method: "PUT",
    data: {
      groupId: "",
      groupImage: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  getGroupDetailByGroupId: {
    url: "/ui/group?groupId=:groupId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  joinMemberInGroup: {
    url: "/ui/group/join",
    method: "POST",
    data: {
      groupId: "",
      userId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  updateSoundTrack: {
    url: "/ui/share/profile",
    method: "PUT",
    data: {
      sharedId: "",
      soundtrack: [],
    },
    showErrorMessage: false,
    showResultMessage: false,
  },

  sendAdminNotification: {
    url: "/ui/notification/sendAdminNotification",
    method: "POST",
    data: {
      notifyUsers: [],
      message: "",
      sendToall: "",
      onlyRole: [],
      buttonText: "",
      buttonUrl: "",
      appModule: "",
      linkType: "",
      type: "",
      detailId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  uiTheme: {
    url: "/ui/theme",
    method: "POST",
    data: {
      themeName: "",
      leaderboardTitle: "",
      leaderboardDescription: "",
      leaderboardBackgroundImg: {},
      leaderboardView: "",
      highlightsView: "",
      highlightsTitle: "",
      highlightsDescription: "",
      highlightsBackgroundImg: {},
      highlights: {},
      explore: [],
      publish: true,
      approved: true,
      userLimit: 0,
      status: "",
      createdBy: "",
      createdByRole: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  updateUiTheme: {
    url: "/ui/theme",
    method: "PUT",
    data: {
      themeId: "",
      themeName: "",
      leaderboardTitle: "",
      leaderboardDescription: "",
      leaderboardBackgroundImg: {},
      leaderboardView: "",
      highlightsView: "",
      highlightsTitle: "",
      highlightsDescription: "",
      highlightsBackgroundImg: {},
      highlights: {},
      explore: [],
      publish: true,
      approved: true,
      userLimit: 0,
      status: "",
      createdBy: "",
      createdByRole: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  themeListing: {
    url: "ui/theme?limit=1000",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  themeDelete: {
    url: "ui/theme",
    method: "DELETE",
    data: {
      themeId: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  getGamification: {
    url: "ui/gamification?gamificationId=:gamificationId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getGamificationList: {
    url: "ui/gamification",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getGroupList: {
    url: `ui/group/groupByUser?userId=${CONSTANTS.ENCRYPT_OPERATION_USERID}&roleId=1`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getFeedList: {
    url: `ui/feed/admin/feedByUser?userId=${CONSTANTS.ENCRYPT_OPERATION_USERID}&roleId=1&skip=:skip`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  getopportunityByUser: {
    url: "ui/feed/admin/opportunityByUser",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  updateGamification: {
    url: "ui/gamification",
    method: "PUT",
    data: {
      activityType: "",
      gamificationId: "",
      actions: [],
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  publishPreview: {
    url: "ui/theme/themepublish",
    method: "PUT",
    data: {
      themeId: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  getBedges: {
    url: "ui/rewardBadges",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  updateBedges: {
    url: "ui/rewardBadges",
    method: "PUT",
    data: { userId: "", roleId: "", badges: [] },
    showResultMessage: false,
    showErrorMessage: false,
  },
  getUsers: {
    url: "/ui/user/notifyUsers",
    method: "POST",
    data: {
      userId: "",
      roleId: "",
      role: [],
      name: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  getUserDetail: {
    url: `ui/theme/getPreLoginUserDetails?limit=:limit`,
    method: "GET",
    data: {
      limit: 0,
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  // Getting university list
  getUniversitiesList: {
    url: `/ui/report/intrestedUniversities?skip=:skip`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  getUniversityReport: {
    // url: `/ui/report/university?university=:org`,
    // method: "GET",
    url: `/ui/report/university`,
    method: "POST",
    data: {
      university: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  // Searching universities report
  getSearchedUniversityReport: {
    url: `/ui/search/intrestedUniversities?search=:word`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  //getting school list
  getSchoolsList: {
    url: `/ui/education/interestedSchools?skip=:skip`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },
  getSchoolReport: {
    // url: `/ui/report/school?school=:org`,
    // method: "GET",
    url: `/ui/report/school`,
    method: "POST",
    data: {
      school: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  // Searching school report
  getSearchedSchoolReport: {
    url: `/ui/education/searchInterestSchools?search=:word`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },

  //getting counselor list
  getCounselorList: {
    url: `/ui/report/statewiseStudents?country=:country&skip=:skip`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },
  getCounselorReport: {
    url: `/ui/report/counselors?state=:state`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },
  getCountryList: {
    url: `/ui/country`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },
  getCountryWiseStates: {
    url: `/ui/report/searchStateStudents?country=:country&state=:word`,
    method: "GET",
    data: {},
    showResultMessage: true,
    showErrorMessage: true,
  },
  studentList: {
    url: "/ui/studentList",
    method: "POST",
    data: {
      institute: "",
      sort_key: "",
      sort_type: "",
      limit: "",
      skip: 0,
      userId: "",
      roleId: "",
      schoolCode: "",
      // search_type: "",
      // search_text: "",
      filter: {},
      loggedInUser: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  AddNotes: {
    url: "/ui/note",
    method: "POST",
    data: {
      userId: "",
      roleId: "",
      note: "",
      notedBy: "",
      notedByRoleId: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  sendNotifyBulkEmail: {
    url: "/ui/user/sendNotifyBulkEmail",
    method: "POST",
    data: {
      userId: "",
      roleId: "",
      message: "",
      studentData: [],
      type: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  changeAdminPassword: {
    url: "/app/admin/changePassword",
    method: "POST",
    data: {
      email: [],
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  resetAdminPassword: {
    url: "/app/admin/changePassword",
    method: "POST",
    data: {
      newPassword: "",
      token_id: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  updateGrade: {
    url: "/ui/user/updateGrade",
    method: "PUT",
    data: {
      inviteId: "",
      inviteBy: "",
      inviteRole: "",
      grade: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  // sas token api
  getSASTokenWithoutLogin: {
    url: "app/azure/sas",
    method: "POST",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  schoolAccountRequests: {
    url: `/ui/admin/schoolAccountRequests?userId=:userId&status=:status&skip=:skip&limit=:limit`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  approveAccountRequest: {
    url: "/ui/admin/approveAccountRequest",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      status: "",
      role: "",
      school: "",
      isAllowAccessControl: "",
      accessModules: {},
      schoolName: "",
      currentSchoolCode: "",
      gradePromotedDate: "",
      sessionPopupDate: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getApprovedBadge: {
    url: `/ui/getApprovedBadge?schoolId=:schoolId&userId=:userId&roleId=:roleId`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  assignBadge: {
    url: "/ui/assignBadge",
    method: "POST",
    data: {
      userList: [],
      badgeList: [],
      userId: "",
      roleId: "",
      message: "",
      schoolId: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  // registration page
  registration: {
    url: "/ui/createAccount",
    method: "POST",
    data: {
      email: "",
      firstName: "",
      lastName: "",
      mobileNo: "",
      countryCode: "",
      roleId: "",
      logo: "",
      school: "",
      schoolCode: "",
      requestMessage: "",
      isAcceptedTermCon: true,
    },
    showResultMessage: false,
    showErrorMessage: true,
  },

  // get admin roles
  getAdminRoles: {
    url: `/ui/admin/roles`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  //manage badges page
  getBadges: {
    // url: `/ui/customBadge?userId=:userId&skip=:skip&limit=:limit`,
    url: `/ui/admin/customBadge?schoolId=:schoolId`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  requestCustomBadge: {
    url: "/ui/admin/customBadge",
    method: "POST",
    data: {
      note: "",
      userId: "",
      roleId: "",
      schoolId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  // change password page
  // changePassword: {
  //   url: "/ui/update/password",
  //   method: "POST",
  //   data: {
  //     oldPassword: "",
  //     newPassword: "",
  //     isAcceptedTermCon: "",
  //   },
  //   showResultMessage: true,
  //   showErrorMessage: true,
  // },

  // profile page
  // update user profile
  updateUserProfile: {
    url: "/ui/admin/profile",
    method: "PUT",
    data: {
      userId: "",
      email: "",
      firstName: "",
      lastName: "",
      mobileNo: "",
      countryCode: "",
      roleId: "",
      logo: "",
      school: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  // get updated data on user profile
  getUpdatedUserDetail: {
    url: `ui/user/getDetail?userId=:userId&roleId=:roleId`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  teacherList: {
    url: `ui/admin/teacher?userId=:userId&roleId=:roleId&skip=:skip&limit=:limit&schoolCode=:schoolCode&sort_key=:sort_key&sort_type=:sort_type&name=:name`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  addTeacherBulk: {
    url: `ui/createAccount`,
    method: "POST",
    data: {
      teachers: [],
      roleId: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  generateMailInviteBulkWithMessage: {
    url: `ui/admin/sendMail`,
    method: "POST",
    data: {
      teachers: [],
      roleId: "",
      userId: "",
      mailMessage: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  generateMailInviteBulk: {
    url: `ui/admin/sendMail`,
    method: "POST",
    data: {
      teachers: [],
      roleId: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  deleteStudentOrTeacher: {
    url: `ui/user/:userId`,
    method: "DELETE",
    data: {
      userId: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },
  configureAccess: {
    url: `ui/admin/accessControl`,
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      schoolCode: "",
      accessControl: {
        allowFeedPost: "",
        feedViewOnly: "",
        hideEntireFeed: "",
        connection: "",
        group: "",
        chat: "",
        profileSharing: "",
        profileVisibility: "",
        chatGPT: "",
      },
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  manageRequestConfigureAccess: {
    url: `ui/admin/accessControl`,
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      schoolCode: "",
      // accessControl: {
      //   allowFeedPost: "",
      //   feedViewOnly: "",
      //   hideEntireFeed: "",
      //   connection: "",
      //   group: "",
      //   profileSharing: "",
      // },
      accessModules: {
        feed: "",
        group: "",
        connection: "",
        profileSharing: "",
      },
      isAllowAccessControl: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },

  getAccessControls: {
    url: "ui/user/accessControl?schoolCode=:schoolCode&userId=:userId&roleId=:roleId",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },

  allStudentListToAssign: {
    url: "/ui/admin/allStudent",
    method: "POST",
    data: {
      schoolCode: "",
      sort_key: "",
      sort_type: "",
      limit: "",
      skip: 0,
      userId: "",
      roleId: "",
      filter: {},
      loggedInUser: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  toAssignStudent: {
    url: "/ui/admin/assignTeacher",
    method: "POST",
    data: {
      userId: "",
      roleId: "",
      students: [],
      teachers: [],
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  permitRoleAccess: {
    url: "/ui/admin/permitRoleAccess",
    method: "PUT",
    data: {
      adminId: "",
      adminRoleId: "",
      userId: "",
      roleId: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  revokeRoleAccess: {
    url: "/ui/admin/revokeRoleAccess",
    method: "PUT",
    data: {
      adminId: "",
      adminRoleId: "",
      userId: "",
      roleId: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  // update user profile
  editUserProfile: {
    url: "/ui/admin/update-teacher",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      email: "",
      firstName: "",
      lastName: "",
      title: "",
      school: "",
    },
    showResultMessage: true,
    showErrorMessage: false,
  },
  dashboardData: {
    url: "/ui/admin/dashboard?schoolCode=:schoolCode&userId=:userId&roleId=:roleId",
    method: "GET",
    data: {
      schoolCode: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  assignedAndDeleteTeacher: {
    url: "/ui/admin/assignAndDeleteTeach",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      schoolCode: "",
      teachers: [],
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  deleteTeacher: {
    url: `ui/teacher`,
    method: "DELETE",
    data: {
      userId: "",
      roleId: "",
      teacherId: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  deleteStudent: {
    url: `ui/student`,
    method: "DELETE",
    data: {
      userId: "",
      roleId: "",
      id: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  assignedTeacher: {
    url: `ui/admin/assignedTeacher?userId=:userId&skip=:skip&limit=:limit&schoolCode=:schoolCode&sort_key=:sort_key&sort_type=:sort_type&name=:name`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  removeAssignedTeacher: {
    url: "/ui/admin/removeTeacher",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      schoolCode: "",
      teachers: [],
      studentId: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  titleList: {
    url: "ui/master/titles",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  // schoolLists: {
  //   url: "ui/master/school",
  //   method: "GET",
  //   data: {},
  //   showResultMessage: false,
  //   showErrorMessage: true,
  // },
  teacherDashboardData: {
    url: "ui/teacher/dashboard?schoolCode=:schoolCode&userId=:userId&roleId=:roleId",
    method: "GET",
    data: {
      schoolCode: "",
      roleId: "",
      userId: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllSchool: {
    url: "ui/master/school",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  getSchoolListBySearch: {
    url: "/ui/master/schools",
    method: "POST",
    data: {
      name: "",
      type: "",
    },
    showResultMessage: false,
    showErrorMessage: false,
  },
  getSchoolListBySearchList: {
    url: "/ui/master/schoolList",
    method: "POST",
    data: {
      name: "",
      type: "",
      skip: 0,
      limit: 50,
      createdBy: undefined,
      sortBy: 'name:asc'
    },
    showResultMessage: false,
    showErrorMessage: false,
  },

  checkEmailExistTeacher: {
    url: "/ui/admin/checkEmailExistence",
    method: "POST",
    data: {
      userId: "",
      roleId: "",
      emails: [],
    },
    showResultMessage: false,
    showErrorMessage: true,
  },

  updateIntroducingFeatures: {
    url: "/ui/updateIntroducingFeatures",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      featureKey: [],
      display: false,
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getSettingData: {
    url: "ui/setting",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  schoolUpdate: {
    url: "app/admin/schoolUpdate",
    method: "PUT",
    data: {
      // schoolCode: "",
      // isPopupViewed: false,
      // isStudentListChecked: false,
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  dateUpdate: {
    url: "app/admin/schoolUpdate",
    method: "PUT",
    data: {
      schoolCode: "",
      roleId: "",
      userId: "",
      isPromotedDateChanged: "",
      gradePromotedDate: "",
      sessionPopupDate: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  handleGetGradeList: {
    url: "ui/admin/getSchoolGrade?userId=:userId&roleId=:roleId&schoolCode=:schoolCode",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  handleGetTeachersList: {
    url: "ui/teacher?schoolCode=:schoolCode&limit=:limit&skip=:skip",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  handleGetStudentListByGrade: {
    url: "ui/admin/studentListByGrade?userId=:userId&roleId=:roleId&schoolCode=:schoolCode&grade=:grade&name=:name",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  handleHoldGradeUpgradtion: {
    url: "/ui/admin/holdGradeUpgration",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      ids: [],
      schoolCode: "",
      grade: "",
      promoteAll: false,
      listReviewed: false,
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  handlePromotionHistory: {
    url: "ui/admin/promotionHistory?userId=:userId&roleId=:roleId&schoolCode=:schoolCode&name=:name&gradeFrom=:gradeFrom&gradeTo=:gradeTo&skip=:skip&limit=:limit",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: false,
  },
  reminderDays: {
    url: `/ui/admin/reminderDays`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getDetailsBySchoolCode: {
    url: `/ui/school/schoolCode?schoolCode=:schoolCode`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  handleAllUsersData: {
    url: "/ui/adm/users",
    method: "POST",
    data: {
      skip: "",
      // role: "",
      name: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },

  handleAllStudentData: {
    url: "ui/admin/search/user?searchText=:searchText",
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },

  handleDeleteUser: {
    url: "/ui/adm/users",
    method: "DELETE",
    data: {
      userId: "",
      roleId: "",
      credential: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  handleUpdateUserDetails: {
    url: "/ui/adm/users",
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      firstName: "",
      lastName: "",
      email: "",
      secondaryEmail: "",
      country: "",
      state: "",
      zipCode: "",
      mobileNo: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  getSingleUserInfo: {
    url: `/ui/adm/user?userId=:userId&roleId=:roleId`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  addDataTOEducator: {
    url: `/ui/adm/addStuToEducator`,
    method: "POST",
    data: {
      educatorId: "",
      schoolCode: "",
      schoolId: "",
      emails: [],
    },
    showResultMessage: false,
    showErrorMessage: true,
  },

  addStuInAdminDashboard: {
    url: `/ui/admin/addStuInAdminDashboard`,
    method: "POST",
    data: {
      educatorEmail: "",
      emails: [],
    },
    showResultMessage: true,
    showErrorMessage: true,
  },

  allowProfileSharing: {
    url: `/ui/admin/allowProfileSharing`,
    method: "PUT",
    data: {
      userId: "",
      roleId: "",
      schoolCode: "",
      studentId: "",
      isProfileSharingEnable: "",
    },
    showResultMessage: true,
    showErrorMessage: true,
  },
  setSchoolControlUpdate: {
    url: `/ui/admin/updateSchool`,
    method: "PUT",
    data: {
      schoolCode: "",
      isSchoolControlUpdated: "",
    },
    showResultMessage: false,
    showErrorMessage: true,
  },

  /** Career Questions - START*/
  getStates: {
    url: `/ui/states`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getStateSchools: {
    url: `/ui/stateSchool?stateCode=:stateCode&skip=:skip&name=:name`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  getAllCareerQuestions: {
    url: `/career/allQuestions?state=:state&gradeType=:gradeType`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  saveCareerQuestions: {
    url: `/career/question`,
    method: "POST",
    data: {
      state: '',
      stateCode: '',
      gradeType: '',
      schoolCodes: [],
      questions: [],
      deletedQuestions: [],
      deletedAnswers: []
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  adminQuestionStates: {
    url: `/career/adminQuestionStates?sortBy=:sortBy`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  /** Career Questions - END*/

  /** Manage Schools */
  getCities: {
    url: `/ui/cities?stateCode=:stateCode&countryCode=:countryCode`,
    method: "GET",
    data: {},
    showResultMessage: false,
    showErrorMessage: true,
  },
  saveSchool: {
    url: `/ui/school`,
    method: "POST",
    data: {
      schoolCode: '',
      name: '',
      city: '',
      stateCode: '',
      address: '',
      zipcode: '',
    },
    showResultMessage: false,
    showErrorMessage: true,
  },
  /** Manage Schools */

};
